// src/styles/GlobalStyles.js
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  @import url("https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;500;600&family=Outfit:wght@300;400;500;600;700&family=Work+Sans:wght@300;400;500;600&display=swap");

  *, *::before, *::after { box-sizing: border-box; }

  html {
    -webkit-text-size-adjust: 100%;
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    background: ${({ theme }) => theme.color.bg};
    color: ${({ theme }) => theme.color.body};
    font-family: ${({ theme }) => theme.font.sans};
    font-size: ${({ theme }) => theme.size.base};
    font-weight: ${({ theme }) => theme.weight.regular};
    line-height: 1.65;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    /* slightly open tracking keeps Work Sans from feeling cramped at body size */
    letter-spacing: 0.002em;
  }

  body.no-scroll { overflow: hidden; }

  h1, h2, h3, h4 {
    margin: 0;
    color: ${({ theme }) => theme.color.ink};
    font-family: ${({ theme }) => theme.font.display};
    font-weight: ${({ theme }) => theme.weight.medium};
    /* Albanian is full of ç, ë, gj and j — 1.08 clipped or collided with
       descenders at display sizes. */
    line-height: 1.14;
    /* Outfit is geometric — negative tracking at display sizes is what makes
       it read as contemporary rather than generic */
    letter-spacing: -0.035em;
    text-wrap: balance;
  }
  h1 { font-size: ${({ theme }) => theme.size.h1}; letter-spacing: -0.045em; }
  h2 { font-size: ${({ theme }) => theme.size.h2}; }

  /* Headlines: Inter Tight, medium weight, tight tracking — clean and
     current without the "template" feel. */
  h1, h2 {
    font-family: ${({ theme }) => theme.font.heading};
    font-weight: ${({ theme }) => theme.weight.medium};
    letter-spacing: -0.04em;
    line-height: 1.08;
  }
  h3 { font-size: ${({ theme }) => theme.size.h3}; letter-spacing: -0.025em; }

  p { margin: 0 0 1rem; text-wrap: pretty; }

  a { color: inherit; text-decoration: none; }

  img, svg, video { display: block; max-width: 100%; }

  button, input, select, textarea { font: inherit; color: inherit; }
  button { cursor: pointer; border: none; background: none; padding: 0; }

  ul, ol { margin: 0; padding: 0; list-style: none; }

  /* Never remove focus rings — keyboard users lose the page entirely */
  :focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.brand};
    outline-offset: 3px;
    border-radius: ${({ theme }) => theme.radius.xs};
  }

  ::selection {
    background: ${({ theme }) => theme.color.ink};
    color: #fff;
  }

  ::-webkit-scrollbar { width: 10px; height: 10px; }
  ::-webkit-scrollbar-track { background: ${({ theme }) => theme.color.bgSoft}; }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.line};
    border-radius: ${({ theme }) => theme.radius.pill};
    border: 2px solid ${({ theme }) => theme.color.bgSoft};
  }
  ::-webkit-scrollbar-thumb:hover { background: ${({ theme }) => theme.color.muted}; }

  .reveal { opacity: 0; will-change: transform, opacity; }

  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    .reveal { opacity: 1 !important; transform: none !important; }
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

export default GlobalStyles;
